import { render } from "./TransferForm.vue?vue&type=template&id=a7e85f4c&scoped=true"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"

import "./TransferForm.vue?vue&type=style&index=0&id=a7e85f4c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e85f4c"]])

export default __exports__